import Loading from '@/components/general/Loading';
import { getTodayFact } from '@/data/thisDayInHistory';
import useProfile from '@/hooks/useProfileV2';
import { getAccessibleServices } from '@/services/serviceRegistry';
import { AppModules } from '@/types';
import CommandCenter from './CommandCenter.component';
import * as Styles from './Dashboard.styles';

type SalutationTime = 'morning' | 'afternoon' | 'night';

const MESSAGE_BY_TIME: Record<SalutationTime, string> = {
  morning: 'Good morning',
  afternoon: 'Good afternoon',
  night: 'Good evening',
};

const EMOJI_BY_TIME: Record<SalutationTime, string> = {
  morning: '\u2600\uFE0F',
  afternoon: '\u2600\uFE0F',
  night: '\uD83C\uDF19',
};

function getTimeOfDay(): SalutationTime {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'afternoon';
  return 'night';
}

const DashboardPage = (): JSX.Element => {
  const { profile } = useProfile();
  const { isLoading = false } = profile;

  if (isLoading) {
    return (
      <Styles.Box>
        <Loading fullPage />
      </Styles.Box>
    );
  }

  const time = getTimeOfDay();
  const firstName = profile.person?.firstName ?? '';
  const greeting = firstName
    ? `${MESSAGE_BY_TIME[time]}, ${firstName}! ${EMOJI_BY_TIME[time]}`
    : `${MESSAGE_BY_TIME[time]}! ${EMOJI_BY_TIME[time]}`;

  const { fact, date } = getTodayFact();

  const accessible = getAccessibleServices(profile.roles ?? []).filter(
    (s) => s.id !== AppModules.HOME
  );

  return (
    <CommandCenter
      greeting={greeting}
      dateString={date}
      todayFact={fact}
      services={accessible}
    />
  );
};

export default DashboardPage;
